import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';

export const PageWrapper = styled.div`
  max-width: 76rem;
  margin: 0 auto;
  font-size: 1.4rem;
  padding: 3.2rem 2rem 6.4rem;
`;

export const PageTitle = styled.h1`
  color: ${p => p.theme.secondaryColor};
  font-weight: 400;
  font-size: 3rem;
  margin: 0 0 2.2rem;
  letter-spacing: 0.02rem;

  ${media.smaller`
    font-size: 2.5rem;
  `};
`;

export const Card = styled.div`
  background-color: ${p => p.theme.tertiaryBgColor || '#fff'};
  border: 0.1rem solid ${p => p.theme.borderColor};
  border-radius: 1rem;
  box-shadow: 0 0.1rem 0.3rem rgba(0, 0, 0, 0.05);
  padding: 2.6rem 2.8rem;

  ${media.smaller`
    padding: 2rem 1.6rem;
  `};
`;

export const CardTitle = styled.h2`
  color: ${p => p.theme.secondaryColor};
  font-weight: 500;
  font-size: 2rem;
  margin: 0 0 1.8rem;
`;

export const Lead = styled.p`
  color: ${p => p.theme.textColor};
  margin: -0.6rem 0 1.8rem;
`;

export const PrepBox = styled.p`
  background-color: rgba(38, 174, 93, 0.08);
  border: 0.1rem solid rgba(38, 174, 93, 0.25);
  border-radius: 0.8rem;
  padding: 1.2rem 1.4rem;
  line-height: 1.8rem;
  color: ${p => p.theme.quinaryTextColor || '#4a5f4b'};
  font-size: 1.4rem;
  margin: 0 0 1.8rem;
`;

export const IntroHeading = styled.h3`
  font-weight: 700;
  color: ${p => p.theme.quaternaryColor};
  font-size: 1.6rem;
  margin: 2.2rem 0 1.2rem;
`;

export const HowList = styled.ol`
  list-style: none;
  margin: 0 0 2rem;
  padding: 0;
`;

export const HowItem = styled.li`
  display: flex;
  gap: 1.2rem;
  align-items: center;
  margin-bottom: 1.2rem;
  color: #555;
`;

export const HowNumber = styled.span`
  flex: 0 0 auto;
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 50%;
  background-color: ${p => p.theme.secondaryColor};
  color: ${p => p.theme.primaryTextColor || '#fff'};
  font-weight: 700;
  font-size: 1.3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.1rem;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 2.2rem;
`;

export const StartButton = styled.button`
  border: none;
  background-color: ${p => p.theme.secondaryColor};
  color: ${p => p.theme.primaryTextColor || '#fff'};
  font-weight: 600;
  letter-spacing: 0.06rem;
  text-transform: uppercase;
  font-size: 1.25rem;
  padding: 1.2rem 2.6rem;
  border-radius: 0.7rem;
  cursor: pointer;
  transition: background-color 0.18s;

  &:hover {
    background-color: ${p => p.theme.secondaryColorHover};
  }
`;
